import { render, staticRenderFns } from "./ChemUCI_51LPL6_Q2.vue?vue&type=template&id=0de1e478&"
import script from "./ChemUCI_51LPL6_Q2.vue?vue&type=script&lang=js&"
export * from "./ChemUCI_51LPL6_Q2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VForm,VImg,VSelect})
